__turbopack_context__.v({
  "button": "InscriptionActionTransfer-module__e3uyMW__button",
  "error": "InscriptionActionTransfer-module__e3uyMW__error",
  "feeSlider": "InscriptionActionTransfer-module__e3uyMW__feeSlider",
  "icon": "InscriptionActionTransfer-module__e3uyMW__icon",
  "input": "InscriptionActionTransfer-module__e3uyMW__input",
  "loading": "InscriptionActionTransfer-module__e3uyMW__loading",
});
